import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { PopularCategoriesFilter, PopularCategory } from "src/types/graphql.d";

const POPULAR_CATEGORIES = gql`
  query popularCategories($filter: PopularCategoriesFilter!) {
    popularCategories(filter: $filter) {
      id
      slug
      name
      thumbnail
      url
    }
  }
`;

interface popularBrandsVarsData {
  popularBrands: PopularCategory[];
}

interface popularBrandsVars {
  filter: PopularCategoriesFilter;
}

const usePopularCategories = (gender: string): any => {
  const { loading, error, data } = useQuery<
    popularBrandsVarsData,
    popularBrandsVars
  >(POPULAR_CATEGORIES, {
    variables: { filter: { gender } },
    ssr: true,
    fetchPolicy: "cache-first",
  });
  return { loading, error, data };
};

export { usePopularCategories };
